import { createContext, useContext } from "react";

/**
 * Which edge of the map a layer-pill column hugs. Pills expand and open their
 * panels away from that edge, so an item needs to know it; a context saves
 * threading the prop through every control between the column and the item.
 */
export type LayerControlSide = "left" | "right";

export const LayerControlSideContext = createContext<LayerControlSide>("right");

export const useLayerControlSide = (): LayerControlSide => useContext(LayerControlSideContext);
